module.exports = __webpack_public_path__ + "media/app_search/Invitation/assets/wordmark-elastic-4070b133c1bdd2b57fd4f7611d6a4740.svg";